module.exports = __webpack_public_path__ + "assets/img/bg-image.5422be91.png";